import React from 'react'
import { Pill } from './pill'

// Whether a connection that is switched on sends anyone to it. Sign-in finds
// connections by the email's domain, so one with no domain bound is offered
// to nobody -- unless it is a public sign-in method (providers.public), a
// button on every sign-in screen. This is auth's provider-link rule since
// audit B3 ("a connection with no domain and no flag is simply not offered to
// anyone until a domain is bound"), and "bound" means what it means there:
// any live binding (domain_bindings), whatever the domain's verification
// state. The reads report it as the connection's bound domains (provider
// domains), providerBindingCount or boundDomainCount -- every organization's,
// not just the one a page is about.
export const NOT_IN_USE_REASON = 'Nobody is sent here: no domain is bound to it.'

// active: switched on. isPublic: providers.public (true / false; anything
// else is unknown). bound: how many domains are bound to it (a number;
// anything else is unknown). A read that doesn't carry the flag or the count
// never claims "Not in use".
export const connectionUse = ({ active, isPublic, bound }) => {
  if (!active) return { key: 'inactive', label: 'Inactive', tone: null }
  if (isPublic === false && bound === 0) return { key: 'not-in-use', label: 'Not in use', tone: null, reason: NOT_IN_USE_REASON }
  return { key: 'active', label: 'Active', tone: 'ok' }
}

// The status pill: green Active, grey Not in use, grey Inactive.
export const ConnectionUsePill = ({ use }) => <Pill tone={use.tone}>{use.label}</Pill>
